import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { PublicHeader } from "@/components/PublicHeader";
import { HeroSection } from "@/components/landing/HeroSection";
import { ValueProposition } from "@/components/landing/ValueProposition";
import { UseCases } from "@/components/landing/UseCases";
import { TestimonialsSection } from "@/components/landing/TestimonialsSection";
import { FinalCTASection } from "@/components/landing/FinalCTASection";
import { LandingFooter } from "@/components/landing/LandingFooter";

const Landing = () => {
  const location = useLocation();

  useEffect(() => {
    document.title = 'CampChef Pro | Camp Meal Planning & Sysco Ordering Software';
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute('content', 'Simplify camp kitchen operations with CampChef Pro — menu planning, inventory tracking, and Sysco ordering built for youth camps, retreats, and outdoor programs.');
    }

    if (location.hash) {
      const element = document.querySelector(location.hash);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    }
  }, [location]);

  return (
    <div className="min-h-screen bg-sand">
      <PublicHeader />
      <HeroSection />
      <ValueProposition />
      <UseCases />
      <TestimonialsSection />
      <FinalCTASection />
      <LandingFooter />
    </div>
  );
};

export default Landing;
